{
  "common.close": "बंद करें",
  "common.athleteFallback": "एथलीट {id}",
  "splash.title": "{app} — गतिविधियों का एनिमेटेड विज़ुअलाइज़ेशन",
  "splash.tagline": "आपके&nbsp;Strava डेटा के लिए चलता-फिरता नक्शा",
  "splash.demo": "डेमो",
  "tab.query.title": "{name} का नक्शा",
  "tab.query.heading": "गतिविधियाँ खोजें:",
  "tab.query.optDays": "हाल के दिन",
  "tab.query.optActivities": "हाल की गतिविधियाँ",
  "tab.query.optIds": "गतिविधि ID",
  "tab.query.optDates": "तारीख़ की सीमा",
  "tab.query.idsPlaceholder": "गतिविधि ID यहाँ डालें",
  "tab.query.after": "के बाद:",
  "tab.query.before": "से पहले:",
  "tab.query.autozoom": "इम्पोर्ट के बाद नतीजों पर अपने-आप ज़ूम <i class=\"hf hf-bullseye\"></i> करें",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> खोजें",
  "tab.query.createAccount": "खाता बनाएँ और/या लॉग इन करें।",
  "tab.query.sports": "खेल:",
  "tab.query.allSports": "सभी खेल",
  "tab.query.sportsExcept": "सभी, इनके सिवा",
  "tab.query.sportsNone": "कोई नहीं",
  "tab.query.loadingSports": "खेल लोड हो रहे हैं…",
  "tab.query.sportsFailed": "इस नक्शे के खेल लोड नहीं हो सके",
  "tab.query.noSports": "अभी कोई गतिविधि नहीं",
  "tab.activities.title": "दिखाई गई गतिविधियाँ",
  "tab.activities.clearSelection": "चयन हटाएँ",
  "tab.activities.renderSelected": "चुनी हुई दिखाएँ",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> चयन पर ज़ूम करें",
  "tab.controls.title": "लेयर सेटिंग्स",
  "tab.controls.timescale": "समय-पैमाना <i>&tau;</i>",
  "tab.controls.timescaleHint": "चलाने की गति",
  "tab.controls.period": "आवर्त <i>T</i>",
  "tab.controls.periodHint": "गतिविधि ~ मॉडल",
  "tab.controls.dotSize": "बिंदु का आकार",
  "tab.controls.pathWidth": "रास्ते की चौड़ाई",
  "tab.controls.pathWidthHint": "शून्य रास्ते छिपा देता है",
  "tab.controls.colors": "रंग",
  "tab.controls.colorsHint": "रंग-पट्टी घुमाएँ",
  "tab.controls.shadows": "छाया",
  "tab.profile.loginTitle": "लॉग इन",
  "tab.profile.anonNote": "अपनी गतिविधियाँ देखने और अपना Heatflask खाता सँभालने के लिए Strava से लॉग इन करें।",
  "tab.profile.loginLink": "Strava से लॉग इन करें",
  "tab.profile.editOnStrava": "Strava पर अपनी प्रोफ़ाइल बदलें",
  "tab.profile.indexNote": "जल्दी पहुँच के लिए हम आपकी गतिविधियों के सारांश का इंडेक्स रखते हैं।",
  "tab.profile.viewIndex": "इंडेक्स देखें",
  "tab.profile.sharedMaps": "साझा नक्शे",
  "tab.profile.sharedMapsNote": "बंद: Heatflask पर आपकी गतिविधियाँ सिर्फ़ आप देख सकते हैं। चालू: जिसके पास भी आपके नक्शे का लिंक है, वह वे गतिविधियाँ देख सकता है जिन्हें आपने Strava पर सार्वजनिक किया है। आपकी निजी गतिविधियाँ दोनों ही सूरत में आपकी ही रहती हैं। <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">गोपनीयता कैसे काम करती है</a>",
  "tab.profile.logout": "लॉग आउट",
  "tab.profile.deleteAccount": "खाता हटाएँ",
  "tab.profile.deleteConfirm": "अपना Heatflask खाता हटाएँ?\n\nइससे आपकी इंडेक्स की गई गतिविधियाँ हट जाएँगी और आपके Strava डेटा तक Heatflask की पहुँच रद्द हो जाएगी। इसे वापस नहीं किया जा सकता।",
  "tab.profile.languageHeading": "भाषा",
  "tab.profile.languageAuto": "अपने-आप",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">अनुवाद सुधारने या नए जोड़ने में हमारी मदद करें!</a>",
  "tab.profile.unitsHeading": "इकाइयाँ",
  "tab.profile.unitsAuto": "अपने-आप",
  "tab.profile.unitsMetric": "मीट्रिक (किमी, मी)",
  "tab.profile.unitsImperial": "इंपीरियल (मील, फ़ुट)",
  "tab.profile.textSizeHeading": "अक्षरों का आकार",
  "tab.profile.textSmaller": "छोटा",
  "tab.profile.textReset": "सामान्य",
  "tab.profile.textLarger": "बड़ा",
  "tab.profile.mapDefaultsHeading": "नक्शे की डिफ़ॉल्ट सेटिंग",
  "tab.profile.mapDefaultsNote": "जब भी आप ऐसा नक्शा खोलें जिसका लिंक अपनी सेटिंग तय नहीं करता, तो इसी बेसमैप, भू-आकृति और लेयर सेटिंग से शुरू करें। आप जो लिंक साझा करते हैं, वे फिर भी ठीक वही दिखाते हैं जो आप देखते हैं।",
  "tab.profile.mapDefaultsSave": "मेरी डिफ़ॉल्ट के रूप में सहेजें",
  "tab.profile.mapDefaultsForget": "भूल जाएँ",
  "tab.info.title": "जानकारी",
  "tab.info.controlsHeading": "नियंत्रण",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + खींचें",
  "tab.info.shiftDragDesc": "एक बॉक्स में गतिविधियाँ चुनें। टचस्क्रीन पर पहले <i class=\"hf-object-group\"></i> दबाएँ, फिर एक उँगली से खींचें। आख़िरी चुनी गई गतिविधि का विवरण दिखता है, और गतिविधि सूची उस तक स्क्रॉल हो जाती है।",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + खींचें",
  "tab.info.ctrlDragDesc": "नक्शे को 3D में घुमाएँ और झुकाएँ, या दो उँगलियों का इस्तेमाल करें",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "साइडबार खोलें या बंद करें",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "पिछला या अगला साइडबार टैब",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "साइडबार बंद करें",
  "tab.info.liveUrlHeading": "लाइव URL",
  "tab.info.liveUrlDesc": "नक्शे का दृश्य और एनिमेशन की सेटिंग पेज के URL में रहती हैं, इसलिए जिसके साथ भी आप इसे साझा करें, वह वही दृश्य देखता है।",
  "tab.info.videoHeading": "वीडियो एक्सपोर्ट",
  "tab.info.videoDesc": "<i class=\"hf-video-camera\"></i> बटन एनिमेशन को MP4 के रूप में रिकॉर्ड करता है: इसे दबाएँ, बॉक्स को नक्शे के जिस हिस्से पर चाहें वहाँ सेट करें, और रिकॉर्ड करने के लिए फिर दबाएँ। एनिमेशन का एक पूरा चक्र रिकॉर्ड होता है, इसलिए वीडियो बिना रुकावट दोहराता है; {max} सेकंड (Strava जितना लंबा वीडियो लेता है) से लंबा चक्र {max} पर काट दिया जाता है।",
  "tab.info.contributeHeading": "योगदान दें",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> GitHub पर सहयोग करें",
  "tab.info.contactsHeading": "संपर्क",
  "map.basemapAndTerrain": "बेसमैप और भू-आकृति",
  "map.pauseAnimation": "एनिमेशन रोकें",
  "map.resumeAnimation": "एनिमेशन जारी रखें",
  "capture.record": "वीडियो रिकॉर्ड करें ({period} से. का चक्र)",
  "capture.recordTruncated": "वीडियो रिकॉर्ड करें (एक चक्र {period} से. का है; सिर्फ़ पहले {max} से. रिकॉर्ड होंगे)",
  "capture.recordArea": "बॉक्स के अंदर का हिस्सा रिकॉर्ड करें",
  "capture.stop": "रिकॉर्डिंग रोकें",
  "capture.selectionTooSmall": "चयन बहुत छोटा है",
  "capture.saved": "{name} सहेजा गया ({size})",
  "capture.cancelled": "रिकॉर्डिंग रद्द हुई",
  "capture.failed": "रिकॉर्डिंग विफल: {error}",
  "capture.loadingEncoder": "एनकोडर लोड हो रहा है…",
  "capture.waitingForMap": "नक्शा लोड होने का इंतज़ार…",
  "capture.encoding": "एनकोड हो रहा है… {percent}%",
  "capture.finalizing": "पूरा किया जा रहा है…",
  "share.title": "इस नक्शे का लिंक साझा करें",
  "share.copied": "लिंक कॉपी हो गया",
  "share.copiedUnshared": "लिंक कॉपी हो गया — लेकिन आपका नक्शा साझा नहीं है, इसलिए कोई और इसे नहीं खोल सकता। इसे बदलने के लिए “साझा नक्शे” चालू करें।",
  "share.unshared": "आपका नक्शा साझा नहीं है, इसलिए कोई और यह लिंक नहीं खोल सकता। इसे बदलने के लिए “साझा नक्शे” चालू करें।",
  "share.copyThis": "यह लिंक कॉपी करें:",
  "update.available": "Heatflask का नया संस्करण उपलब्ध है।",
  "update.reload": "फिर से लोड करें",
  "import.title": "इम्पोर्ट हो रहा है",
  "import.stop": "रोकें",
  "import.stopping": "रुक रहा है…",
  "import.contacting": "Strava से संपर्क हो रहा है…",
  "import.countOf": "गतिविधियाँ: {total} में से {received}",
  "import.count": "गतिविधियाँ: {received}",
  "import.waitStrava": "Strava की डाउनलोड सीमा के कारण {time} तक रुका है। यह पेज खुला रहने दें; दोबारा लोड करने से यह तेज़ नहीं होगा।",
  "import.waitRationed": "आज के तेज़ डाउनलोड पूरे हो गए। बाकी {time} पर धीरे-धीरे जारी रहेंगे। यह पेज खुला रहने दें।",
  "import.dailyLimit": "Strava की दैनिक डाउनलोड सीमा पूरी हो गई। {time} के बाद फिर से कोशिश करें।",
  "import.dailyRationed": "आज के लिए Strava डाउनलोड में आपका हिस्सा पूरा हो गया। {time} के बाद फिर से कोशिश करें।",
  "import.noActivitiesYet": "आपके Strava खाते में अभी कोई गतिविधि नहीं है। Strava पर कोई गतिविधि रिकॉर्ड या अपलोड करें, वह यहाँ दिखाई देगी।",
  "table.noActivities": "कोई गतिविधि नहीं",
  "table.untitled": "(बिना शीर्षक)",
  "activities.pageTitle": "{app} — गतिविधि इंडेक्स",
  "activities.heading": "गतिविधि इंडेक्स",
  "activities.fetching": "गतिविधियाँ लाई जा रही हैं...",
  "activities.rateLimit": "Strava की अनुरोध-सीमा पूरी हुई; {time} पर फिर शुरू होगा",
  "activities.noData": "माफ़ करें, कोई डेटा नहीं &#128577;",
  "activities.colServerCache": "ट्रैक सर्वर पर सहेजा गया (Mongo)",
  "activities.colBrowserCache": "ट्रैक इस ब्राउज़र में सहेजा गया",
  "activities.cachedServer": "{id} का ट्रैक सर्वर पर सहेजा गया है",
  "activities.notCachedServer": "{id} का ट्रैक सर्वर पर सहेजा नहीं गया है",
  "activities.cachedBrowser": "{id} का ट्रैक इस ब्राउज़र में सहेजा गया है",
  "activities.notCachedBrowser": "{id} का ट्रैक इस ब्राउज़र में सहेजा नहीं गया है",
  "sport.AlpineSki": "अल्पाइन स्कीइंग",
  "sport.BackcountrySki": "बैककंट्री स्कीइंग",
  "sport.Badminton": "बैडमिंटन",
  "sport.Basketball": "बास्केटबॉल",
  "sport.Canoeing": "कैनोइंग",
  "sport.Cricket": "क्रिकेट",
  "sport.Crossfit": "क्रॉसफ़िट",
  "sport.Dance": "नृत्य",
  "sport.EBikeRide": "ई-बाइक सवारी",
  "sport.Elliptical": "एलिप्टिकल",
  "sport.EMountainBikeRide": "ई-माउंटेन बाइक सवारी",
  "sport.Golf": "गोल्फ़",
  "sport.GravelRide": "ग्रेवल सवारी",
  "sport.Handcycle": "हैंडसाइकिल",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "पैदल यात्रा",
  "sport.IceSkate": "आइस स्केटिंग",
  "sport.InlineSkate": "इनलाइन स्केटिंग",
  "sport.Kayaking": "कयाकिंग",
  "sport.Kitesurf": "काइटसर्फ़िंग",
  "sport.MountainBikeRide": "माउंटेन बाइक सवारी",
  "sport.NordicSki": "नॉर्डिक स्कीइंग",
  "sport.Padel": "पैडल",
  "sport.PhysicalTherapy": "फ़िज़ियोथेरेपी",
  "sport.Pickleball": "पिकलबॉल",
  "sport.Pilates": "पिलाटेस",
  "sport.Racquetball": "रैकेटबॉल",
  "sport.Ride": "साइकिल सवारी",
  "sport.RockClimbing": "रॉक क्लाइंबिंग",
  "sport.RollerSki": "रोलर स्की",
  "sport.Rowing": "नौकायन",
  "sport.Run": "दौड़",
  "sport.Sail": "पाल नौकायन",
  "sport.Skateboard": "स्केटबोर्ड",
  "sport.Snowboard": "स्नोबोर्ड",
  "sport.Snowshoe": "स्नोशू",
  "sport.Soccer": "फ़ुटबॉल",
  "sport.Squash": "स्क्वैश",
  "sport.StairStepper": "स्टेयर स्टेपर",
  "sport.StandUpPaddling": "स्टैंड अप पैडलिंग",
  "sport.Surfing": "सर्फ़िंग",
  "sport.Swim": "तैराकी",
  "sport.TableTennis": "टेबल टेनिस",
  "sport.Tennis": "टेनिस",
  "sport.TrailRun": "ट्रेल रन",
  "sport.Velomobile": "वेलोमोबाइल",
  "sport.VirtualRide": "वर्चुअल सवारी",
  "sport.VirtualRow": "वर्चुअल नौकायन",
  "sport.VirtualRun": "वर्चुअल दौड़",
  "sport.Volleyball": "वॉलीबॉल",
  "sport.Walk": "सैर",
  "sport.WeightTraining": "वेट ट्रेनिंग",
  "sport.Wheelchair": "व्हीलचेयर",
  "sport.Windsurf": "विंडसर्फ़िंग",
  "sport.Workout": "वर्कआउट",
  "sport.Yoga": "योग"
}
